import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getUserByLinkId        : ["payload"],
  uploadDocumentByLinkId : ["payload"]
}, { prefix: "accreditation_link_" });

export { Types, Creators };
